/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { AdminSettingsDto } from "../types/adminSettingsDto";

import type { ProblemDetails } from "../types/problemDetails";

import type { UpdateAdminSettingsDto } from "../types/updateAdminSettingsDto";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const getSettings = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AdminSettingsDto>> => {
  return axios.default.get(`/api/users/me/settings`, options);
};

export const getGetSettingsQueryKey = () => {
  return [`/api/users/me/settings`] as const;
};

export const getGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = AxiosError<ProblemDetails>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({
    signal,
  }) => getSettings({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettings>>
>;
export type GetSettingsQueryError = AxiosError<ProblemDetails>;

export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = AxiosError<ProblemDetails>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateSettings = (
  updateAdminSettingsDto: UpdateAdminSettingsDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AdminSettingsDto>> => {
  return axios.default.patch(
    `/api/users/me/settings`,
    updateAdminSettingsDto,
    options,
  );
};

export const getUpdateSettingsMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: UpdateAdminSettingsDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: UpdateAdminSettingsDto },
  TContext
> => {
  const mutationKey = ["updateSettings"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSettings>>,
    { data: UpdateAdminSettingsDto }
  > = (props) => {
    const { data } = props ?? {};

    return updateSettings(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSettings>>
>;
export type UpdateSettingsMutationBody = UpdateAdminSettingsDto;
export type UpdateSettingsMutationError = AxiosError<ProblemDetails>;

export const useUpdateSettings = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: UpdateAdminSettingsDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: UpdateAdminSettingsDto },
  TContext
> => {
  const mutationOptions = getUpdateSettingsMutationOptions(options);

  return useMutation(mutationOptions);
};
